const isAllChecked = (proposalCheckboxes) => {
  return proposalCheckboxes.length > 0 && proposalCheckboxes.every((cb) => cb.checked);
};

const openCheckedProposals = (proposalCheckboxes) => {
  const checked = proposalCheckboxes.filter((cb) => cb.checked);
  if (checked.length === 0) {
    window.alert("チェックが入った提案がありません");
    return;
  }

  let blocked = false;
  checked.forEach((cb) => {
    const url = cb.dataset.detailUrl;
    if (!url) return;

    const newWindow = window.open(url, "_blank");
    if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
      blocked = true;
    }
  });

  if (blocked) {
    window.alert("ポップアップがブロックされました。ブラウザのサイト設定でポップアップを許可する必要があります");
  }
};

export const setupProposalBulkSelect = () => {
  const selectAllCheckboxes = Array.from(document.querySelectorAll(".select-all"));
  const proposalCheckboxes = Array.from(document.querySelectorAll(".proposal-checkbox"));
  const openCheckedButton = document.getElementById("open-checked");

  if (selectAllCheckboxes.length === 0 && proposalCheckboxes.length === 0 && !openCheckedButton) return;

  const syncSelectAllState = () => {
    const allChecked = isAllChecked(proposalCheckboxes);
    selectAllCheckboxes.forEach((selectAll) => { selectAll.checked = allChecked; });
  };

  selectAllCheckboxes.forEach((selectAll) => {
    selectAll.addEventListener("change", () => {
      const checked = selectAll.checked;
      proposalCheckboxes.forEach((cb) => { cb.checked = checked; });
      selectAllCheckboxes.forEach((other) => { if (other !== selectAll) other.checked = checked; });
    });
  });

  proposalCheckboxes.forEach((cb) => {
    cb.addEventListener("change", syncSelectAllState);
  });

  document.querySelectorAll(".proposal-checkbox-cell").forEach((cell) => {
    cell.addEventListener("click", (event) => {
      if (event.target.tagName === "INPUT") return;

      const input = cell.querySelector(".proposal-checkbox");
      if (!input) return;

      input.checked = !input.checked;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  if (openCheckedButton) {
    openCheckedButton.addEventListener("click", () => openCheckedProposals(proposalCheckboxes));
  }
};

document.addEventListener("DOMContentLoaded", setupProposalBulkSelect);
